import { useEffect, useState } from 'react'
import { Skeleton } from '@chakra-ui/react'

import { ProfessionalContractType } from 'InstitutionalManagement/types'
import ProfessionalContractTypeCard from 'InstitutionalManagement/components/ProfessionalContractTypeCard'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import getProfessionalContractTypeOnCustomForm from './services/getProfessionalContractTypeOnCustomForm'

export default function CustomFormAnswerProfessionalContractType() {
  const [loadingProfessionalContractType, setLoadingProfessionalContractType] = useState<boolean>(false)
  const [ProfessionalContractType, setProfessionalContractType] = useState<ProfessionalContractType>({})

  const { answer } = useCustomFormAnswer()

  const answerValue = answer.answer ? answer.answer[0] : ''

  const professionalContractTypeId: string = answerValue

  async function getProfessionalContractType() {
    setLoadingProfessionalContractType(true)
    const response = await getProfessionalContractTypeOnCustomForm({ professionalContractTypeId })
    if (response?.header?.success) {
      const professionalContractTypeFromAPI = response?.body?.contract_type
      setProfessionalContractType(professionalContractTypeFromAPI)
    }
    setLoadingProfessionalContractType(false)
  }

  useEffect(() => {
    if (answerValue) getProfessionalContractType()
  }, [answerValue])

  return (
    <Skeleton isLoaded={!loadingProfessionalContractType}>
      <ProfessionalContractTypeCard
        borderWidth="1px"
        borderColor="borderColor"
        professionalContractType={ProfessionalContractType}
      />
    </Skeleton>
  )
}
